import React, { ReactElement } from "react";
import { GetStaticProps } from "next";
import SeveralBrandsWrapper from "@components/layouts/severalBrandsWrapper";
import ThirdSection from "@components/severalbrands/howWeWorkPage/secondSection";
import WhyPartnerWithUs from "@components/severalbrands/whyPartnerWithUs";
import MiddleSection from "@components/severalbrands/howWeWorkPage/middleSection";
import FirstSection from "@components/severalbrands/howWeWorkPage/firstSection";
import { DomainInfo } from "@components/severalbrands/utils/services";
import initialCall from "@components/severalbrands/utils/initialCall";
import MetaTags from "@components/severalbrands/metaTags";
import {
    getKeyWordsForMetaTags,
    getMetaTitleDescriptionForPage,
} from "@components/severalbrands/utils";

const partnerWitUSDataHowWeWorkPage = {
    title: "Why Partner with Several Brands?",
    paragraphs: [
        {
            text: `At Several Brands, you're a growth ally, not just a client; we only succeed when you do. Our vertical experts, spanning legal, B2B, software, and B2C, build and adjust campaigns around your goals, backed by lead validation that combines AI screening with human review, and flexible engagement terms rather than a rigid, one-size-fits-all contract. If a lead doesn't fit, we'll swap or credit it, no hassle.`,
            className: "default",
        },
        {
            text: `From lead generation to reporting, we handle the full process so your team can focus on closing.`,
            className:
                "mt-6  3xl:max-w-[1040px] 3xl:text-xl max-w-[740px]  font-light",
        },
    ],
    buttonText: "Talk to Our Sales Team",
};

export default function SeveralBrandsHome({
    domain,
}: {
    domain: DomainInfo;
}): ReactElement {
    const metaTags = getMetaTitleDescriptionForPage(domain, "HowWeWork");
    return (
        <SeveralBrandsWrapper domainInfo={domain}>
            <MetaTags
                title={metaTags?.title ?? "How We Work | SeveralBrands.com"}
                description={
                    metaTags?.description ??
                    "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks."
                }
                keyWords={getKeyWordsForMetaTags(domain)}
            />
            <FirstSection />
            <div className="h-[5000px]"></div>
            <ThirdSection />
            <MiddleSection domainInfo={domain} />
            <div className="mt-32 lg:mt-56 lg:mb-48 mb-20">
                <WhyPartnerWithUs
                    partnerWitUSData={partnerWitUSDataHowWeWorkPage}
                />
            </div>
        </SeveralBrandsWrapper>
    );
}

//@ts-ignore
export const getStaticProps: GetStaticProps = async () => {
    return await initialCall("HowWeWork");
};
